import axios from 'axios';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createStory } from '../_actions/storiesActions';
import { isEmpty } from 'lodash';
import { ShowCenterSpinner } from '../_components/common/statelessView';
import { searchFormatWithSlug } from '../_actions/slidePresetActions';
import { ACCESS_DENIED, NOT_FOUND } from '../_utils/routes';

function AutoCreateDesignVideoProject({ history, match }) {
  const signal = axios.CancelToken.source();
  const workspacePermissionChecks = useSelector(
    (state) => state.permissions.workspacePermissionChecks
  );
  const dispatch = useDispatch();

  const {
    params: { format },
  } = match;

  const [isCreate, setIsCreate] = useState(true);
  const { canCreateStory } = workspacePermissionChecks;

  const fetchFormatInformation = () => {
    dispatch(
      searchFormatWithSlug(
        format || 'instagram-stories',
        history,
        createDesignVideoProject
      )
    );
  };

  function createDesignVideoProject(formatDetails) {
    return dispatch(
      createStory(
        {
          status: 'draft',
          format: formatDetails.id,
          image_height: `${formatDetails.image_height}`,
          image_width: `${formatDetails.image_width}`,
          title: formatDetails.display_name,
          story_type: formatDetails.story_type,
        },
        signal.token,
        {history: history}
      )
    );
  }
  useEffect(() => {
    if (isCreate && !isEmpty(workspacePermissionChecks)) {
      setIsCreate(false);
      if (!canCreateStory) {
        return history.push(ACCESS_DENIED);
      } else {
        fetchFormatInformation();
      }
    }
  }, [workspacePermissionChecks]);
  return <ShowCenterSpinner loaded={false}></ShowCenterSpinner>;
}

export default withRouter(AutoCreateDesignVideoProject);
